import type { MailboxInfo } from "owa-client-types";
import { getAccountScopeUserSettings } from "./getAccountScopeUserSettings";

export default function getIsFocusedInboxEnabled(mailboxInfo: MailboxInfo): boolean | undefined {
    const userSettings = getAccountScopeUserSettings(mailboxInfo);
    const isFocusedInboxEnabled = userSettings?.UserOptions?.IsFocusedInboxEnabled;
    
    if (typeof isFocusedInboxEnabled === "boolean") {
        return isFocusedInboxEnabled;
    }
    
    // If the value is undefined, return true because this is the user's first
    // session and the expectation is that F/O is enabled.
    return true;
}
